import {
	AlternativeStylesPropertiesTypography,
	Box,
	Spacer,
	Typography,
	useTheme,
	Button,
	ComposableTypography,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import { Anything } from '@types';
import { useMembershipCompletionEnterpriseSolutionHelper } from './membershipCompletionEnterpriseSolution.helper';

type TypographyStyles = React.CSSProperties & AlternativeStylesPropertiesTypography;

export const MembershipCompletionEnterpriseSolution: React.FC = () => {
	const {
		resources,
		icon,
		iconBgColor,
		appearanceSolutionName,
		solutionName,
		solutionNameWithoutLastWord,
		solutionNameLastWord,
		premiumSolution,
		defaultSolutionName,
		onHandlePress,
	} = useMembershipCompletionEnterpriseSolutionHelper();
	const { palette } = useTheme();

	return (
		<Box styles={{ justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
			<Spacer vertical={rem(36)} />
			{/* Card success or pending */}
			<Box styles={{ position: 'relative' }}>
				<Box
					styles={{
						backgroundColor: iconBgColor,
						borderRadius: '50%',
						position: 'absolute',
						top: 0,
						left: '50%',
						transform: 'translateX(-50%) translateY(-50%)',
						padding: rem(4),
					}}
				>
					{icon}
				</Box>
				<Box
					styles={{
						backgroundColor: palette.global.ui18,
						borderRadius: rem(16),
						overflow: 'hidden',
						backfaceVisibility: 'hidden',
						width: rem(392),
						justifyContent: 'center',
						alignItems: 'center',
						textAlign: 'center',
					}}
				>
					<Box
						styles={{
							padding: rem(32),
						}}
					>
						{solutionName === premiumSolution ? (
							<ComposableTypography
								text={`${solutionNameWithoutLastWord} <highlight>${solutionNameLastWord}</highlight>`}
								baseProps={{
									appearance: appearanceSolutionName,
								}}
								tags={{
									highlight: {
										appearance: appearanceSolutionName,
										alternativeStyleProperties: {
											color: palette.global.ui1,
										} as Anything,
									},
								}}
							/>
						) : (
							<Typography appearance={appearanceSolutionName}>{defaultSolutionName}</Typography>
						)}
					</Box>
				</Box>
			</Box>
			<Spacer vertical={rem(40)} />
			{/* Title and subtitle */}
			<Box styles={{ flexDirection: 'column', width: rem(409) }}>
				<Typography
					appearance="subtitle-100-04"
					alternativeStyleProperties={{ wordBreak: 'break-all', textAlign: 'center' } as TypographyStyles}
				>
					{resources.statusTitle}
				</Typography>
				<Spacer vertical={rem(16)} />
				<Typography
					appearance="body-75-02"
					alternativeStyleProperties={
						{ wordBreak: 'break-all', textAlign: 'center', color: '#80838F' } as TypographyStyles
					}
				>
					{resources.statusDescription}
				</Typography>
			</Box>
			<Spacer vertical={rem(48)} />
			{/* Button */}
			<Button onPress={onHandlePress}>{resources.selectSolutionIziBizi}</Button>
		</Box>
	);
};
